export enum CashFlowRowTypeEnum {
  REVENUE = 'R',
  DEDUCTION = 'D',
  CALCULATED = 'C',
}